import { NgStyle } from "@angular/common";
import { Component, ElementRef, Input, inject } from "@angular/core";
import { Tooltip } from "primeng/tooltip";

@Component({
    selector: "app-loading-spinner",
    imports: [NgStyle, Tooltip],
    templateUrl: "./loading-spinner.component.html",
})
export class LoadingSpinnerComponent {
    @Input() tooltip: string;
    @Input() divStyle?: any;
    @Input() id?: string = undefined;

    private ele: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);

    constructor() {}
}
